module.exports = __webpack_public_path__ + "img/ticket20.737111cb.png";